import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = "", testid }) => (
  <motion.div
    data-testid={testid}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, label, light = false }) => (
  <p
    className={`flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-[#f57c00] ${
      light ? "" : ""
    }`}
  >
    <span className="font-mono-edu">{index}</span>
    <span className={`h-px w-8 ${light ? "bg-white/25" : "bg-[#c5cae9]"}`} />
    <span className="font-mono-edu">{label}</span>
  </p>
);